<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editarroles="editarroles($event)"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
      :cols="columnas"
    ></tablita>

    <!-- Modal roles -->
    <div
      class="modal fade"
      id="modal_roles"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        :class="`modal-dialog modal-dialog-centered modal-lg`"
        role="document"
        style="width: 80%"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              ROLES QUE TIENEN EL PERMISO "{{ `${item ? item.name : ""}` }}"
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Rol</th>
                      <th class="text-center">Guard</th>
                      <th class="text-center">Asignar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(r, idx) in roles" :key="idx">
                      <td>{{ r.name }}</td>
                      <td>{{ r.name_guard }}</td>
                      <td>
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          :value="r.id"
                          v-model="r.check"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- <pre>{{menus_ids}}</pre> -->
            <!-- <pre>{{menus}}</pre> -->
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
            <button
              type="button"
              @click="guardar_roles"
              :class="`btn btn-primary`"
            >
              GUARDAR
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal menus -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "name",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "name",
      },
      {
        key: "guard_name",
        label: "Guard",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "guard_name",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
      {
        label: "Roles",
        clase: "btn-primary",
        evento: "editarroles",
        icono: "fas fa-universal-access",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "name",
        valor: "",
        label: "Nombre (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "guard_name",
        valor: "api",
        label: "Guard (*)",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Permiso",
      ancho: "lg",
      ruta: "/permissions",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Permisos",
      titulo_boton: "Crear Permiso",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    item: null,
    roles: [],
    roles_ids: [],
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }

    this.cargar_roles();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_roles() {
      await this.axios
        .get(`${this.api}/roles?limit=99999`, this.cabeceras_json)
        .then((res) => {
          this.roles = res.data.data.data;
          this.resetear_roles();
          //console.log('roles',this.roles);
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },

    resetear_roles() {
      this.roles.forEach((r) => {
        r.check = false;
      });
    },

    setear_roles() {
      this.roles.forEach((r) => {
        let check = this.roles_ids.findIndex((id) => r.id == id);
        if (check != -1) {
          r.check = true;
        }
      });
    },

    async cargar($event) {
      this.pagina_actual = `${this.api}/permissions${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/permissions${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/permissions`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });

      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/permissions/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },

    editarroles(event) {
      this.item = event.item;
      //console.log('item',this.item);
      this.roles_ids = this.item.roles_ids;
      $("#modal_roles").modal({ show: true });
    },

    async guardar_roles() {
      let body = {
        roles_ids: this.roles.filter((r) => r.check == true).map((r) => r.id),
      };
      await this.axios
        .post(
          `${this.api}/permissions/${this.item.id}/guardar_roles`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log('respuesta',res.data);
          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.inputs[1].valor = "api";
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>